import React, { useEffect, useState, useRef } from 'react';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import $ from 'jquery';
import Progress from './ui/react-ui/progress.jsx';
import LogisticsListTable from './lineDashboard/logisticsList_table';
import LogisticsTerminalListTable from './lineDashboard/logisticsTerminalList_table';
import LogisticsListForecastTable from './lineDashboard/logisticsList_forecast_table';
import LogsTerminalsTable from './lineDashboard/logs_terminals_table'; // api

import { getLogsLogisticsUnfinished, getLogsLogisticsForecast, getLogsTerminalsUnfinished, getLogsLogisticsTerminalUnfinished } from '../api/statsAPI';
import { getAreaTerminals } from '../api/areaAPI'; // redux

import { setTerminalsList, setLogisticsTerminalUnfinished, setLogisticsUnfinished, setLogisticsForecast, setLogisticsList, setLogsTerminals, reset } from '../redux/line-dashboard';
var t = i18n.getFixedT(null, 'line-dashboard');
var LineDashboard = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$lineDash = _useSelector.lineDashboard,
      logisticsUnfinishedSort = _useSelector$lineDash.logisticsUnfinishedSort,
      logisticsForecastSort = _useSelector$lineDash.logisticsForecastSort,
      logsTerminalsSort = _useSelector$lineDash.logsTerminalsSort,
      logisticsTerminalUnfinishedSort = _useSelector$lineDash.logisticsTerminalUnfinishedSort;

  var dispatch = useDispatch();
  useEffect(function () {
    Progress.startSpin();
    var logsLogisticsUnfinished = getLogsLogisticsUnfinished(contextRoot, true, null, null, logisticsUnfinishedSort, 0, 10);
    var logsLogisticsterminalUnfinished = getLogsLogisticsTerminalUnfinished(contextRoot, true, null, null, logisticsTerminalUnfinishedSort, 0, 10);
    var logsLogisticsForecast = getLogsLogisticsForecast(contextRoot, true, null, 'notZoneIn', logisticsForecastSort, 0, 10);
    var logsTerminalsUnfinished = getLogsTerminalsUnfinished(contextRoot, true, null, null, logsTerminalsSort, 0, 10);
    var getTermainals = getAreaTerminals(contextRoot, true);
    $.when(logsLogisticsUnfinished, logsLogisticsterminalUnfinished, logsLogisticsForecast, logsTerminalsUnfinished, getTermainals).then(function (logsLogisticsUnfinishedResult, logsLogisticsterminalUnfinishedResult, logsLogisticsForecastResult, logsTerminalsUnfinishedResult, result_termainals) {
      var logisticsUnfinished = _.cloneDeep(logsLogisticsUnfinishedResult);

      _.map(logisticsUnfinished.content, function (el, index) {
        el.sequence = index + 1;
      });

      dispatch(setLogisticsUnfinished(logisticsUnfinished));

      var logisticsTerminalUnfinished = _.cloneDeep(logsLogisticsterminalUnfinishedResult);

      _.map(logisticsTerminalUnfinished.content, function (el, index) {
        el.sequence = index + 1;
      });

      dispatch(setLogisticsTerminalUnfinished(logisticsTerminalUnfinished));

      var logisticsForecast = _.cloneDeep(logsLogisticsForecastResult);

      _.map(logisticsForecast.content, function (el, index) {
        el.sequence = index + 1;
      });

      dispatch(setLogisticsForecast(logisticsForecast));

      var logsterminalsUnfinished = _.cloneDeep(logsTerminalsUnfinishedResult);

      _.map(logsterminalsUnfinished.content, function (el, index) {
        el.sequence = index + 1;
      });

      dispatch(setLogsTerminals(logsterminalsUnfinished));

      var terminalsList = _.map(result_termainals.content, function (el) {
        return {
          value: el.id,
          text: el.name
        };
      });

      dispatch(setTerminalsList(terminalsList));
      Progress.done();
    }).catch(function (error) {
      console.log(error);
      Progress.done();
    });
    return function () {
      dispatch(reset());
    };
  }, []);
  var id = props.id;
  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement(LogisticsListTable, null), /*#__PURE__*/React.createElement(LogisticsTerminalListTable, null), /*#__PURE__*/React.createElement(LogsTerminalsTable, null), /*#__PURE__*/React.createElement(LogisticsListForecastTable, null));
});
LineDashboard.defaultProps = {
  id: 'g-line-dashboard'
};
LineDashboard.PropTypes = {
  id: PropTypes.string
};
export default LineDashboard;